import { Component } from '@angular/core';

@Component({
  selector: 'app-delivery-content',
  templateUrl: './delivery-content.component.html',
  styleUrls: ['./delivery-content.component.scss']
})
export class DeliveryContentComponent {}
